module.exports = __webpack_public_path__ + "112cb2b3231667a1a9630f95e1274b7d.png";